import { get } from 'lodash'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { deleteEvent, getCurrentOutOfOfficeEvents, patchEvent, postOutOfOfficeEvent } from '@apis/calendars/CalendarEventManager'
import { getCompany } from '@actions/currentUser'

const initialState = {
  events: [],
  loading: false,
  error: null,
}

export const fetchEvents = createAsyncThunk('outOfOffice/fetchEvents', async (_, { rejectWithValue }) => {
  try {
    const response = await getCurrentOutOfOfficeEvents()
    return response.data
  } catch (err) {
    return rejectWithValue(get(err, 'response.data'))
  }
})

export const addEvent = createAsyncThunk('outOfOffice/addEvent', async (eventDetails, { dispatch, rejectWithValue }) => {
  try {
    await postOutOfOfficeEvent(eventDetails)
    dispatch(getCompany())
    const response = await getCurrentOutOfOfficeEvents()
    return response.data
  } catch (err) {
    return rejectWithValue(get(err, 'response.data'))
  }
})

export const updateEvent = createAsyncThunk('outOfOffice/removeEvent', async (eventDetails, { dispatch, rejectWithValue }) => {
  const { id } = eventDetails
  try {
    await patchEvent(id, eventDetails)
    dispatch(getCompany())
    const response = await getCurrentOutOfOfficeEvents()
    return response.data
  } catch (err) {
    return rejectWithValue(get(err, 'response.data'))
  }
})

export const removeEvent = createAsyncThunk('outOfOffice/removeEvent', async (eventId, { dispatch, rejectWithValue }) => {
  try {
    await deleteEvent(eventId)
    dispatch(getCompany())
    const response = await getCurrentOutOfOfficeEvents()
    return response.data
  } catch (err) {
    return rejectWithValue(get(err, 'response.data'))
  }
})

const fetching = (state) => {
  state.loading = true
  state.error = null
}

const fetchSuccess = (state, action) => {
  state.events = action.payload
  state.loading = false
  state.error = null
}

const fetchFailure = (state, action) => {
  state.loading = false
  state.error = action.payload
}

const outOfOfficeSlice = createSlice({
  name: 'outOfOffice',
  initialState,
  extraReducers: {
    [fetchEvents.pending]: fetching,
    [fetchEvents.fulfilled]: fetchSuccess,
    [fetchEvents.rejected]: fetchFailure,
    [addEvent.pending]: fetching,
    [addEvent.fulfilled]: fetchSuccess,
    [addEvent.rejected]: fetchFailure,
    [updateEvent.pending]: fetching,
    [updateEvent.fulfilled]: fetchSuccess,
    [updateEvent.rejected]: fetchFailure,
    [removeEvent.pending]: fetching,
    [removeEvent.fulfilled]: fetchSuccess,
    [removeEvent.rejected]: fetchFailure,
  },
})

export default outOfOfficeSlice.reducer
